import { Lock } from "lucide-react";
import { Badge } from "~/components/ui/badge";

export const ReadOnlyBadge = () => (
  <Badge variant="secondary" className="rounded-full">
    <Lock aria-hidden="true" />
    Read-only
  </Badge>
);
